.f5{width:max-content;}